// extracted by mini-css-extract-plugin
module.exports = {"required_label":"RequiredLabel_required_label__3tZb6"};